<template>
    <div v-if="isTyping" class="active-team-chat-typing-indicator-wrapper position-sticky fixed-bottom">
        <div class="active-team-chat-typing-indicator small text-black">
            <div>
                {{ getUsersTyping(activeChat) }}
                {{ $tc("team-chats.typing", isMoreThanOneTyping ? 0 : 1) }}...
            </div>
        </div>
    </div>
</template>

<script>
import useActiveTeamChat from "../useActiveTeamChat";

export default {
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isTyping() {
            return this.activeChat?.usersTyping?.length > 0;
        },
        isMoreThanOneTyping() {
            return this.activeChat?.usersTyping?.length > 1;
        },
    },
    setup() {
        const { getUsersTyping } = useActiveTeamChat();

        return {
            getUsersTyping,
        };
    },
};
</script>
